import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadTestData = () => {
    return {
        type: actionTypes.LOAD_TEST_DATA
    }
}

export const setTestData = (testData) => {
    return {
        type: actionTypes.SET_TEST_DATA,
        testData: testData
    }
}

export const loadCompletedTestData = () => {
    return {
        type: actionTypes.LOAD_COMPLETED_TEST_DATA
    }
}

export const setCompletedTestData = (completedTestData) => {
    return {
        type: actionTypes.SET_COMPLETED_TEST_DATA,
        completedTestData: completedTestData
    }
}

export const loadTestQuestions = () => {
    return {
        type: actionTypes.LOAD_TEST_QUESTIONS
    }
}

export const setTestQuestions = (testQuestions) => {
    return {
        type: actionTypes.SET_TEST_QUESTIONS,
        testQuestions: testQuestions
    }
}

export const loadSubmitTest = () => {
    return {
        type: actionTypes.LOAD_SUBMIT_TEST
    }
}

export const setSubmitTest = (correctAnswers) => {
    return {
        type: actionTypes.SET_SUBMIT_TEST,
        correctAnswers: correctAnswers
    }
}

export const getTestData = (token) => {
    return (dispatch) => {
        dispatch(loadTestData())
        axios.get(`/api/v1/test/getTests`)
            .then(response => {
                dispatch(setTestData(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const getCompletedTestData = (token) => {
    return (dispatch) => {
        dispatch(loadCompletedTestData())
        axios.get(`/api/v1/test/getCompletedTests`)
            .then(response => {
                dispatch(setCompletedTestData(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const getTestQuestions = (testResultId) => {
    return (dispatch) => {
        dispatch(loadTestQuestions())
        axios.get(`/api/v1/test/getTestQuestions?testResultId=` + testResultId, {
        })
            .then(response => {
                dispatch(setTestQuestions(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const postSubmitTest = (testResult) => {
    return (dispatch) => {
        dispatch(loadSubmitTest())
        axios.post(`/api/v1/test/submitResults`, testResult)
            .then(response => {
                dispatch(setMessage({type: 'success', text: "Тест завершен."}))
                dispatch(setSubmitTest(response.data))
                dispatch(getTestData())
                dispatch(getCompletedTestData())
            })
            .catch(error => {
                dispatch(setMessage({type: 'error', text: "Не удалось завершить тест, результаты не сохранились."}))
                dispatch(getTestData())
                dispatch(getCompletedTestData())
            });
    }
}
